#!/usr/bin/env node

import {Command} from 'commander';

import {readPackageVersion} from '@/utilities/fetch';

import 'dotenv/config';
import {add} from '@/commands/add';
import {configure} from '@/commands/configure';
import {init} from '@/commands/init';

process.on('SIGINT', () => process.exit(0));
process.on('SIGTERM', () => process.exit(0));

const main = async () => {
  const version = await readPackageVersion();

  const program = new Command()
    .name('kog')
    .description('a CLI tool to add KOG components to your project')
    .version(`Kog CLI version ${version ?? 'unknown'}`, '--version', 'display the version number');

  program.addCommand(init).addCommand(add).addCommand(configure).parse();
};

main();
